import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import CommonForm from '../CommonForm';
import { getFormData } from './util';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import dayjs from 'dayjs';

const JiraForm = (props: {
  issueNumber: string;
  open: boolean;
  setOpen: AnyFunc;
  getFormInstance: AnyFunc;
}) => {
  const [formData, setFormData] = useState<any>(getFormData());
  const getRoverVersionList = async () => {
    const param = {
      path: '/monitor/web/jira/get_rover_list',
      method: 'POST',
    };
    request(param).then((res) => {
      if (res.code === HttpStatusCode.Success) {
        const data =
          res?.data?.map((item: string) => {
            return {
              label: item,
              value: item,
            };
          }) || [];
        const version = formData?.data?.find(
          (item: FieldItem) => item.fieldName === 'version'
        );
        if (version) {
          version.data = data;
        }
        setFormData({
          ...formData,
        });
      }
    });
  };

  useEffect(() => {
    getRoverVersionList();
  }, []);

  return (
    <CommonForm
      className="jira-form-content"
      config={formData}
      layout="inline"
      defaultValue={{
        severity: 'MINOR',
        isCrash: '0',
        debugTime: [dayjs().format('YYYY-MM-DD HH:mm:ss')],
      }}
      getFormInstance={(ref) => {
        props.getFormInstance(ref);
      }}
    />
  );
};

export default JiraForm;
